import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import {
  openRateHistory,
  fetchUserList,
  fetchCageRateList,
} from 'reducers/slaMonitor/reducer'
import CageContainer from './CageContainer'
import WidgetContainer from '../../WidgetContainer'
import CageDrawer from './CageDrawer'
import messages from '../translate'
import 'styles/app/apps/slaMonitor/cagesBlock.scss'

class SurfaceLevelActivity extends Component {
  componentDidMount() {
    this.props.fetchUserList()
  }

  render() {
    const {
      intl: { formatMessage },
    } = this.props

    return (
      <WidgetContainer name={formatMessage(messages.slaTitle)}>
        <div className="cages-paper">
          <CageContainer />
          <CageDrawer />
        </div>
      </WidgetContainer>
    )
  }
}

export default connect(null, {
  openRateHistory,
  fetchCageRateList,
  fetchUserList,
})(injectIntl(SurfaceLevelActivity))
